import React from "react";
import { useTranslation } from "react-i18next";
import { FiX, FiCheck, FiArrowLeft } from "react-icons/fi";
import styles from "./ModalConfirmInject.module.scss";

/**
 * Modale de confirmation d'injection des presets par defaut.
 * Propose le CHOIX du mode : "replace" (remplace) ou "append" (ajoute a la suite).
 *
 * Props :
 *  - userCount   : nombre d'utilisateurs cibles
 *  - types       : ["test"] | ["cr"] | ["test","cr"]
 *  - mode        : "replace" | "append"
 *  - setMode     : setter du mode
 *  - onConfirm   : callback de confirmation
 *  - onCancel    : callback d'annulation
 *  - success     : bool (affiche le message de succes)
 *  - loading     : bool (desactive le bouton)
 */
const ModalConfirmInject = ({
  userCount,
  types = [],
  mode,
  setMode,
  onConfirm,
  onCancel,
  success,
  loading,
}) => {
  const { t } = useTranslation();

  const typeLabel = types
    .map((tp) =>
      tp === "test" ? t("preset.preset_test") : t("preset.preset_reports")
    )
    .join(" + ");

  return (
    <div className={styles.modal}>
      <button type="button" className={styles.closeBtn} onClick={onCancel}>
        <FiX />
      </button>

      <h3>{t("preset.inject_confirm_title")}</h3>

      <p className={styles.summary}>
        {t("preset.inject_confirm_summary", {
          count: userCount,
          types: typeLabel,
        })}
      </p>

      <div className={styles.modeChoice}>
        <label
          className={`${styles.modeOption} ${
            mode === "replace" ? styles.modeActive : ""
          }`}
        >
          <input
            type="radio"
            name="injectMode"
            value="replace"
            checked={mode === "replace"}
            onChange={() => setMode("replace")}
          />
          <span className={styles.modeTitle}>{t("preset.mode_replace")}</span>
          <span className={styles.modeDesc}>
            {t("preset.mode_replace_desc")}
          </span>
        </label>

        <label
          className={`${styles.modeOption} ${
            mode === "append" ? styles.modeActive : ""
          }`}
        >
          <input
            type="radio"
            name="injectMode"
            value="append"
            checked={mode === "append"}
            onChange={() => setMode("append")}
          />
          <span className={styles.modeTitle}>{t("preset.mode_append")}</span>
          <span className={styles.modeDesc}>
            {t("preset.mode_append_desc")}
          </span>
        </label>
      </div>

      <div className={styles.actions}>
        <button type="button" className={styles.btnDanger} onClick={onCancel}>
          <FiArrowLeft /> {t("common.cancel")}
        </button>
        <button
          type="button"
          className={styles.btnPrimary}
          onClick={onConfirm}
          disabled={loading}
        >
          <FiCheck /> {t("preset.inject_confirm_action")}
        </button>
      </div>
    </div>
  );
};

export default ModalConfirmInject;
